/**
 * Package Access Service (Frontend)
 * API calls för paket-baserad åtkomstkontroll
 */

import api from '../api/client';

export interface PackageAccessResult {
  hasAccess: boolean;
  reason?: string;
  subscriptionType?: 'included' | 'addon' | 'demo' | 'trial' | null;
  expiresAt?: string | null;
  restrictions?: {
    maxVehicles?: number;
    maxUsers?: number;
    isReadOnly?: boolean;
    daysRemaining?: number;
  };
}

export interface ModuleAccessInfo {
  moduleId: string;
  moduleName: string;
  accessType: 'package' | 'addon' | 'demo' | 'trial' | null;
  subscriptionType?: string;
  expiresAt?: string;
}

export interface MyFeaturesResponse {
  features: string[];
  modules?: ModuleAccessInfo[];
  isUnlimited: boolean;
  subscriptionType?: string;
}

export const packageAccessService = {
  /**
   * Hämta mina tillgängliga features baserat på paket
   */
  getMyFeatures: async (): Promise<MyFeaturesResponse> => {
    const response = await api.get('/api/packages/my-features');
    return response.data.data;
  },

  /**
   * Kolla åtkomst till en specifik feature
   */
  checkFeatureAccess: async (featureCode: string): Promise<PackageAccessResult> => {
    const response = await api.get(`/api/packages/check-feature/${featureCode}`);
    return response.data.data;
  },
};
